import App from './App.svelte';
import './assets/css/reset.scss';
import './assets/css/spacing.scss';
import './assets/css/absoluteSpacing.scss';
import './assets/css/size.scss';
import './assets/css/helper.scss';
import './assets/css/color.scss';
import './assets/css/custom.scss';
import './assets/css/dark.scss';


const app = new App({
	target: document.body,
});

export default app;
